import { type CSSProperties } from 'react';
import { LinkBase, Image, Text } from '@belong/ui';
import { ApprovalFormSubmitButton } from 'pages/PostInspectionFlow/approval-form-submit-button/approval-form-submit-button';

type Props = {
  children: string;
  isDisabled: boolean;
  style?: CSSProperties;
};

export function ApprovalFormSubmitBar({ children, isDisabled, style }: Props) {
  return (
    <div
      className="fixed left-0 top-0 z-fullscreen w-full bg-navy"
      style={{ height: 60, ...style }}
    >
      <div className="container flex h-full items-center justify-between before:content-none after:content-none">
        <div className="flex items-center">
          <div className="mr-xl hidden xl:flex">
            <LinkBase
              href="/"
              aria-label="Go To Homepage"
              style={{ width: 77, height: 27 }}
            >
              <Image
                src="/logos/belong_logo_web_white.svg"
                alt=""
                aria-hidden="true"
              />
            </LinkBase>
          </div>
        </div>
        <div className="flex h-xl flex-row">
          <ApprovalFormSubmitButton isDisabled={isDisabled}>
            <Text variant="p1" fontWeight="semibold">
              {children}
            </Text>
          </ApprovalFormSubmitButton>
        </div>
      </div>
    </div>
  );
}
